__turbopack_context__.v({
  "container": "ButtonsShare-module-scss-module__4s5QSa__container",
  "container__option": "ButtonsShare-module-scss-module__4s5QSa__container__option",
});
